(() => {
  const init = () => {
    const root = document.querySelector('[data-rhum-quiz]');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const steps = [...root.querySelectorAll('.lm-rhum-quiz__step')];
    const progress = root.querySelector('.lm-rhum-quiz__progress-bar');
    const results = root.querySelector('[data-results]');
    const summary = root.querySelector('[data-result-summary]');
    const cards = [...root.querySelectorAll('[data-product-card]')];
    const restart = root.querySelector('[data-restart]');
    const answers = {};
    let current = 0;

    const animate = (targets, vars) => {
      if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.gsap.to(targets, vars);
      } else {
        Object.assign(targets.style || {}, { opacity: 1, transform: 'none' });
      }
    };

    const showStep = (index) => {
      steps.forEach((step, i) => {
        step.hidden = i !== index;
        step.classList.toggle('is-active', i === index);
      });
      current = index;
      if (progress) {
        const width = `${((index + 1) / steps.length) * 100}%`;
        if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.gsap.to(progress, { width, duration: .5, ease: 'power3.out' });
        } else progress.style.width = width;
      }
      const active = steps[index];
      if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.gsap.fromTo(active.querySelectorAll('.lm-rhum-quiz__choice, h2, .lm-rhum-quiz__eyebrow'), {opacity:0,y:24}, {opacity:1,y:0,duration:.65,stagger:.07,ease:'power3.out'});
      }
    };

    const getCategory = () => {
      if (answers.taste === 'gourmands') return 'rhums-arranges-gourmands';
      if (answers.taste === 'epices') return 'rhums-arranges-epices';
      return 'rhums-arranges-fruites';
    };

    const showResults = () => {
      const category = getCategory();
      const intensity = answers.style || 'equilibre';
      const occasion = answers.occasion || 'plaisir';
      const intensityLabel = intensity === 'doux' ? 'doux et accessible' : intensity === 'intense' ? 'avec du caractère' : 'équilibré';
      const occasionLabel = occasion === 'cadeau' ? 'pour offrir' : occasion === 'partage' ? 'à partager' : 'pour vous';
      const tasteLabel = answers.tasteLabel || 'fruité';

      // 1) On tente d'abord la famille choisie.
      cards.forEach(card => {
        const isFallback = card.hasAttribute('data-fallback-card');
        card.dataset.hidden = (!isFallback && card.dataset.category === category) ? 'false' : 'true';
      });

      let visible = cards.filter(card => card.dataset.hidden !== 'true');
      let usedFallback = false;

      // 2) Sécurité absolue : si la collection ciblée est vide/non publiée,
      // on affiche jusqu'à 4 produits de la collection principale.
      if (visible.length === 0) {
        const fallbackCards = cards.filter(card => card.hasAttribute('data-fallback-card')).slice(0, 4);
        fallbackCards.forEach(card => { card.dataset.hidden = 'false'; });
        visible = fallbackCards;
        usedFallback = true;
      }

      if (summary) {
        summary.textContent = usedFallback
          ? `Vous recherchez quelque chose de ${tasteLabel.toLowerCase()}, ${intensityLabel}, ${occasionLabel}. Cette famille est momentanément limitée : voici quelques recettes Le Manuscris que nous vous recommandons.`
          : `Vous recherchez quelque chose de ${tasteLabel.toLowerCase()}, ${intensityLabel}, ${occasionLabel}. Voici une sélection Le Manuscris à découvrir.`;
      }

      steps.forEach(step => step.hidden = true);
      results.hidden = false;
      current = steps.length;

      if (window.gsap && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.gsap.fromTo(results.querySelector('.lm-rhum-quiz__results-head'), {opacity:0,y:30}, {opacity:1,y:0,duration:.8,ease:'power3.out'});
        window.gsap.fromTo(visible, {opacity:0,y:45,scale:.98}, {opacity:1,y:0,scale:1,duration:.75,stagger:.1,ease:'power3.out',delay:.15});
      }
      results.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    };

    root.addEventListener('click', event => {
      const choice = event.target.closest('.lm-rhum-quiz__choice');
      if (choice) {
        if (current === 0) { answers.taste = choice.dataset.answer; answers.tasteLabel = choice.dataset.label; }
        if (current === 1) { answers.style = choice.dataset.answer; answers.styleLabel = choice.dataset.label; }
        if (current === 2) { answers.occasion = choice.dataset.answer; answers.occasionLabel = choice.dataset.label; }
        if (current < steps.length - 1) showStep(current + 1); else showResults();
      }
    });

    restart?.addEventListener('click', () => {
      Object.keys(answers).forEach(key => delete answers[key]);
      results.hidden = true;
      showStep(0);
      root.scrollIntoView({behavior:'smooth', block:'start'});
    });

    showStep(0);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();

  document.addEventListener('shopify:section:load', init);
})();
